import { useFormContext } from 'react-hook-form';

import { TooltipButton } from '@/components/molecules/tooltip-button';
import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';

export const AddEventButton = (): React.ReactNode => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });
  const form = useFormContext();

  const handleAddEvent = () => {
    const data = form.getValues();
    const currentEvents = data.defrostSchedule ?? [];
    // Zero out seconds/ms — defrost schedules only have minute-level precision,
    // and leftover seconds from new Date() would be persisted to the server.
    const now = new Date();
    now.setSeconds(0, 0);
    form.setValue(
      'defrostSchedule',
      [...currentEvents, { startTime: now, endDate: undefined, eventDays: [] }],
      {
        shouldDirty: true,
        shouldValidate: true,
      }
    );
  };

  return (
    <TooltipButton
      disabled={disabledByPermissions}
      onClick={handleAddEvent}
      className="btn btn-sm"
      tooltipContent={tooltipText}
    >
      Add Event
    </TooltipButton>
  );
};
